export default __webpack_public_path__ + "static/media/student_wel_hi.87de1563.jpg";